import UiPageListSearch from "./UiPageListSearch";
import UiPageListSearch_DynamicSearchItem from "./UiPageListSearch_DynamicSearchItem";
import { EnumUiDynamicSearchItemType } from "./EnumUiDynamicSearchItemType";
import { EnumCompare } from "./EnumCompare";
import { EnumOrderServiceType, EnumOrderServiceTypeOption } from "./EnumOrderServiceType";

/**
 * 报关/清关的历史记录分页列表-搜索条件分页列表-搜索条件
 * @description 自动生成的代码,请勿修改
 */
export default class DtoPageListSearchOrderDepartureHistory extends UiPageListSearch {
    constructor() {
        //无参构造函数
        super()
    }

    [proName: string]: any;
    /**
     * 订单主键
     */
    OrderId?: string;
    /**
     * 委托书主键
     */
    PoolId?: string;
    /**
     * 仓库/堆场/码头主键
     */
    OrderDepartureId?: string;
    /**
     * 服务类型
     */
    Service?: EnumOrderServiceType;
}

/**
 * 报关/清关的历史记录分页列表-搜索条件分页列表-搜索条件-表单校验
 */
export const DtoPageListSearchOrderDepartureHistoryRules = {
}

/**
 * 报关/清关的历史记录分页列表-搜索条件分页列表-搜索条件-动态搜索配置项
 */
export const DtoPageListSearchOrderDepartureHistoryDynamicSearchItems: UiPageListSearch_DynamicSearchItem[]  = [
]
